import KeenSlider from 'keen-slider'
import 'keen-slider/keen-slider.min.css'

export class AutowidthSliders {
  constructor() {
    this.slidersEl = [...document.getElementsByClassName('js-autowidth-slider')]
    if (this.slidersEl.length === 0) return
    const animation = (num) => ({ duration: num * 7500, easing: (t) => t })
    this.sliders = this.slidersEl
      .map((sliderEl) => {
        sliderEl.classList.add('keen-slider')
        const { loop, automove, twice } = sliderEl.dataset
        if (twice !== undefined) {
          if (twice === '') {
            sliderEl.innerHTML += sliderEl.innerHTML
          } else {
            for (let i = 0; i < Number(twice); i++) {
              sliderEl.innerHTML += sliderEl.innerHTML
            }
          }
        }

        const slidesEl = [...sliderEl.children]
        const slidesLength = slidesEl.length
        if (slidesLength === 0) return null
        slidesEl.forEach((slideEl) => {
          slideEl.classList.add('keen-slider__slide')
        })
        return new KeenSlider(
          sliderEl,
          automove === undefined
            ? {
                slides: {
                  perView: 'auto',
                },
                loop: loop !== undefined,
              }
            : {
                slides: {
                  perView: 'auto',
                },
                loop: true,
                mode: 'free',
                renderMode: 'performance',
                created(s) {
                  s.moveToIdx(slidesLength - 1, true, animation(slidesLength - 1))
                },
                updated(s) {
                  s.moveToIdx(s.track.details.abs + slidesLength - 1, true, animation(slidesLength - 1))
                },
                animationEnded(s) {
                  s.moveToIdx(s.track.details.abs + slidesLength - 1, true, animation(slidesLength - 1))
                },
              },
        )
      })
      .filter((s) => s)
  }
}
